import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { loadStripe } from "@stripe/stripe-js";
import {
  PaymentElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";

import SpinnerComponent from "../../../../components/Loder/spinner";
import { API, STRIPEPUBLICKEY } from "../../../../backend";

export default function NewsubscriptionCheckoutForm({
  userData,
  updatestate,
  paymentintentid,
  isLoading,
  setIsLoading,
  company_name,
  name,
  email,
  phone_number,
  address,
  country,
  state,
  city,
  zip_code,
  userAllow,
  amount,
  start_date,
  end_date,
  sub_amount,
  plan,
  planId,
  password,
  clientSecret,
  customer_id,
  subscription_id,
  subscription_date,
  subscription_status,
  selectMethod,
  promotionCode,
  renewal_date
}) {
  const [message, setMessage] = useState(null);
  const [data, setData] = useState([]);
  const [ipAddress, setIPAddress] = useState("");
  const currentUrl = window.location.origin;
  const navigate = useNavigate();
  const stripe = useStripe();
  const stripepromise = loadStripe(STRIPEPUBLICKEY);
  const [Loading, setLoading] = useState(false);
  const elements = useElements();
  const options = {
    clientSecret: clientSecret,
    appearance: {
      /* */
    },
  };
  useEffect(() => {
    fetch("https://api.ipify.org?format=json")
      .then((response) => response.json())
      .then((data) => {
        setIPAddress(data.ip);
        handlepaymentintentupdate()
      })
      .catch((error) => console.log(error));
    // }
  }, []);

  const handlepaymentintentupdate = async ()=>{
    try {
      const body = {
        paymentintent_id:paymentintentid ,
        companyName:company_name,
        name:name,
        phoneNumber:phone_number,
        email:email,
        address:address,
        country_name:country,
        stateName:state,
        city:city,
        zipCode:zip_code,
        ipAddress:ipAddress,
        userallow:userAllow,
        amount:amount * 100,
        start_date:start_date,
        end_date:end_date,
        renewal_date:renewal_date,
        sub_total:sub_amount * 100,
        payment_method_type : selectMethod,
        promotion_code :promotionCode,
        plan_id :planId
      }
      if(body.companyName !== '' && body.name !== '' && body.zipCode !== ''){
        const response = await fetch(
          API+'accounting/update-payment-intent/', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(body),
        });
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
  
        const data = await response.json();
        setData(data)
      }
    } catch (error) {
      console.error('Error fetching client secret:', error);
    }
  }

  const handleSubmit = async (e) => {
      e.preventDefault();
      userData(true)
    if (!stripe || !elements) {
      return;
    }
    userData(false)

    // setIsLoading(true);
    setLoading(true)
    
    const { error } = await stripe.confirmPayment({
        elements, 
        confirmParams: {
              // return_url: currentUrl+"/newConfirm?",           
              return_url: currentUrl+ "/confirm?",           
            },
    });
    if (error.type === "card_error" || error.type === "validation_error") {
      setMessage(error.message);
    setLoading(false)

    } else {
      setMessage("An unexpected error occurred.");
    setLoading(false)

    }
    setLoading(false)
  // }
  };

  const paymentElementOptions = {
    layout: "tabs",
  };

  return (
    <>
   {Loading && <SpinnerComponent />}
      <form
        id="payment-form"
        // onSubmit={createSubscription}
        onSubmit={handleSubmit}
      >
        {/* <div className="" id="payment-element"> */}
          <PaymentElement
            id="payment-element"
            options={paymentElementOptions}
          />
        {/* </div> */}
        <button className="btn btn-primary" disabled={Loading} id="submit">
          Subscribe
        </button>
        <div id="error-message">
          {message && <div id="payment-message">{message}</div>}
        </div>
      </form>
    </>
  );
}
